<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="gotoManageSalesRep()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                Manage Sales Rep
            </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">
            <div class="row d-felx justify-content-center">

                <div class="col-sm-12 col-md-5 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Sales Rep Name</mat-label>
                        <input matInput appInputtext maxlength="50" formControlName="salesRepName"
                            placeholder="Enter Sales Rep Name" required class="col-12" autocomplete="off">
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-5 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Sales Rep Code</mat-label>
                        <input matInput appInputtext maxlength="10" formControlName="salesRepCode"
                            placeholder="Enter Sales Rep Code" required class="col-12" autocomplete="off">
                    </mat-form-field>
                </div>

            </div>
            <div class="d-flex justify-content-center button-style">
                <button class="btn btn-primary mb-3 mr-3 mt-5" type="button" (click)="gotoManageSalesRep()"
                    matButton>Cancel</button>
                <button class="btn btn-secondary mb-3 mt-5" (click)="onsubmit()" matButton>{{paramsid ===0
                    ?'Save': 'Update'}}</button>
            </div>
        </form>
    </div>
</div>